import { inject, Injectable } from '@angular/core';
import { injectMutation, injectQuery, QueryClient } from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';

import { QUERY_KEYS } from '@core/constans';
import { StorageService } from '@core/services';
import { environment } from '@environments/environment';
import { ApiResponse } from '@core/types';
import { StorageFileInfo, StoragePreSignDownloadRequest } from '@core/types/storage.type';

@Injectable({ providedIn: 'root' })
export class StorageQuery {
  private readonly storage = inject(StorageService);
  private readonly queryClient = inject(QueryClient);

  useListFiles(module: () => string, subFolder: () => string | undefined, maxKeys: () => number | undefined) {
    return injectQuery(() => {
      const m = module();
      const s = subFolder();
      const k = maxKeys();
      return {
        queryKey: QUERY_KEYS.storage.list(m, s, k),
        queryFn: () => lastValueFrom(this.storage.listFiles(m, s, k)),
        select: (res: ApiResponse<StorageFileInfo[]>) => res.data,
        staleTime: environment.staleTime,
      };
    });
  }

  useDeleteObject() {
    return injectMutation(() => ({
      mutationFn: (data: StoragePreSignDownloadRequest) => lastValueFrom(this.storage.deleteObject(data)),
      onSuccess: (_res, variables) => {
        this.queryClient.invalidateQueries({ queryKey: QUERY_KEYS.storage.all });
        this.queryClient.invalidateQueries({ queryKey: QUERY_KEYS.storage.list(variables.module, variables.subFolder) });
      },
    }));
  }
}

